import { Dialog, DialogActions, DialogTitle, DialogContent, DialogContentText, Button } from "@mui/material";
import './CAlertBox.css';

const CAlertBox = ({handleClose, open, message}) => {
    return (
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="calertbox-main-container"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description" color='#000'>
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    );
}

export default CAlertBox;